/* Machine à Short — interactions légères (sans dépendance).
   - Lecteur de démos : onglets Faceless / Avatar, son à la demande, pause hors écran.
   - Barre d'achat collante : visible quand le bouton principal sort de l'écran. */

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-mas-demo]').forEach((demo) => {
    const video = demo.querySelector('video');
    const tabs = demo.querySelectorAll('[data-mas-tab]');
    const sound = demo.querySelector('[data-mas-sound]');
    const caption = demo.querySelector('[data-mas-caption]');
    if (!video) return;

    const select = (tab) => {
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      video.src = tab.dataset.src;
      video.poster = tab.dataset.poster;
      if (caption) caption.textContent = tab.dataset.caption || '';
      if (!reduceMotion) video.play().catch(() => {});
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => select(tab)));

    if (sound) {
      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        sound.textContent = video.muted ? sound.dataset.on : sound.dataset.off;
        if (!video.muted) video.play().catch(() => {});
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !reduceMotion) video.play().catch(() => {});
          else video.pause();
        },
        { threshold: 0.25 },
      ).observe(video);
    }
  });

  // Lecteurs intégrés : la vidéo ne se charge qu'au clic ; un seul joue à la fois.
  document.querySelectorAll('[data-mas-player]').forEach((player) => {
    player.addEventListener('click', () => {
      if (player.querySelector('video, iframe')) return;
      document.querySelectorAll('[data-mas-player] video').forEach((v) => v.pause());
      // Short YouTube : lecteur sans cookies, chargé seulement maintenant, lu dans la carte.
      if (player.dataset.youtube) {
        // Un seul lecteur YouTube ouvert à la fois : on referme les autres (retour à l'aperçu).
        document.querySelectorAll('[data-mas-player] iframe').forEach((f) => {
          f.closest('[data-mas-player]')?.classList.remove('is-playing');
          f.remove();
        });
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(player.dataset.youtube)}?autoplay=1&playsinline=1&rel=0`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.title = player.querySelector('img')?.alt || 'Vidéo';
        player.classList.add('is-playing');
        player.appendChild(frame);
        return;
      }
      const video = document.createElement('video');
      video.src = player.dataset.src;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.poster = player.querySelector('img')?.src || '';
      player.classList.add('is-playing');
      player.appendChild(video);
      video.addEventListener('play', () => {
        document.querySelectorAll('[data-mas-player] video').forEach((v) => {
          if (v !== video) v.pause();
        });
      });
      video.play().catch(() => {});
    });
  });

  const sticky = document.querySelector('[data-mas-sticky]');
  const anchor = document.querySelector('[data-mas-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const pastIt = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', pastIt);
      sticky.setAttribute('aria-hidden', String(!pastIt));
    }).observe(anchor);
  }
})();
